import { IsNumber } from 'class-validator';

export class BusinessEntityFireDto {
  id: number;

  @IsNumber()
  fireIcan?: number;

  @IsNumber()
  fireBalance?: number;

  @IsNumber()
  businessEntityBankId?: number;
}
